import React from 'react';
import classNames from 'classnames';
import styled from '@emotion/styled';
import { Box } from 'reflexbox';
import { FontAwesome } from '../../../FontAwesome';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../../Style/breakpoints';

const StyledButton = styled.button`
  font-family: Avenir, sans-serif;
  cursor: pointer;
  color: #3e4b4c;
  font-size: 16px;
  border: none;
  outline: none;
  padding: 14px 16px;
  background-color: transparent;
  flex-grow: 1;
  width: 100%;
  display: flex;
  border-top: 1px solid #e5eaeb;
  justify-content: space-between;

  font-size: 16px;
  line-height: 140%;
  color: #000000;
  .arrow-cirle {
    display: none;
  }

  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 140%;
    flex-grow: 0;
    border-top: none;
    justify-items: center;
    align-items: center;
    color: #3e4b4c;
    &:hover {
      color: #cf1b53;
      background: transparent;
    }
    .chevron-down {
      display: none;
    }
    .arrow-cirle {
      display: inline-block;
    }
  }
`;

export const NavItem = React.memo(
  ({
    name,
    onClick,
    className,
  }: {
    name: string;
    onClick: () => void;
    className?: string;
  }) => {
    return (
      <StyledButton
        className={classNames('subnavbtn', className)}
        onClick={onClick}
      >
        <Box mr={1}>{`${name}`}</Box>
        <FontAwesome name="arrow-circle-down" className="arrow-cirle" />
        <FontAwesome name="chevron-down" className="chevron-down" />
      </StyledButton>
    );
  }
);
